import * as React from "react"
import {useEffect} from "react"
import {Box, Grid} from "@mui/material";

import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import {HOME_ROUTES, SHARE_OF_SEARCH_ROUTES} from "@constants";
import {isSystemBusy} from "@signals";
import {resetShareOfSearchKpiSignals} from "./@signals";
import ShareOfSearchKpiFilters from "./Filters";
import ShareOfSearchKpiTable from "./Table";
import ShareOfSearchKpiTableDetails from "./Details";
import ShareOfSearchKPIEvolutionChart from "./EvolutionChart";


export default function ShareOfSearchKpiPage() {

    useEffect(() => {
        return () => resetShareOfSearchKpiSignals()
    }, []);

    return <PageWrapper
        tourPageKey="sosKpi"
        head={`DIP Insight | ${SHARE_OF_SEARCH_ROUTES.SHARE_TITLE}`}
        title={SHARE_OF_SEARCH_ROUTES.SHARE_TITLE}
        subtitle={SHARE_OF_SEARCH_ROUTES.SHARE_SUBTITLE}
        isEmpty={false}
        filters={<ShareOfSearchKpiFilters />}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={3}>
            <Grid item xs={12} sx={{ position: "relative" }}>
               <TourTarget name="sos-kpi-table" height={300} />
               <ShareOfSearchKpiTable />
            </Grid>

            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="sos-kpi-details" height={300} />
                <ShareOfSearchKpiTableDetails />
            </Grid>

            <Grid item xs={12}>
                <ShareOfSearchKPIEvolutionChart />
            </Grid>
        </Grid>
    </PageWrapper>
}